import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=e4b3bc0c&scoped=true"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=e4b3bc0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b3bc0c",
  null
  
)

export default component.exports